// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        // loadProductFirst: true,
        styleScrollToTop: 'style2',
        defaultDisplay: bcSfFilterConfig.custom.layout,
    },
};

var bcSfFilterTemplate = {
    'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',

    // Grid Template
    'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
    'soldOutLabelGridHtml': ' <span class="product-price__sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
    'productGridItemHtml': '<li class="grid__item grid__item--collection-template grid_view_custom_product {{itemGridWidthClass}}">' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<a href="{{itemUrl}}"><div class="grid-view-item {{itemSoldOutClass}} product-card">' +
                                    //'<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{itemUrl}}">' +
                                        //'<span class="visually-hidden">{{itemTitle}}</span>' +
                                    //'</a>' +
                                    '{{imageStyle}}' +
                                    '{{itemImages}}' +
                                    '<div class="details_outer_custom" >' +
                                        '<div class="h4 grid-view-item__title tesdeft"><a href="{{itemUrl}}">{{itemTitle}}</a></div>' +
                                       '<div classs="price-product price-custom" zxx>{{itemPrice}}</div>' +
  										'<div class="small_dv" >{{itemDescription}}</div>' +
                                    '</div>' +
                                '</div></a>' +
                            '</div>',

    // List Template
    'vendorSmallListHtml': '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
    'vendorMediumListHtml': '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
    'saleLabelListHtml': '<div class="list-view-item__on-sale">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelListHtml': '<div class="list-view-item__sold-out">' + bcSfFilterConfig.label.sold_out + '</div>',
    'productListItemHtml':  '<li href="{{itemUrl}}" class="list-view-item">' +
                                '<div class="product-card product-card--list">' +
                                    '<div class="list-view-item__link">' +
                                        '<div class="list-view-item__image-column">' +
                                            '<div class="list-view-item__image-wrapper">' +
                                                '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="list-view-item__title-column">' +
                                            '<div class="list-view-item__title">{{itemTitle}}</div>' +
                                            '{{itemSaleLabel}}' +
                                            '{{itemMediumVendor}}' +
                                            '{{itemSoldOutLabel}}' +
                                        '</div>' +
                                        '{{itemSmallVendor}}' +
                                        '<div class="list-view-item__price-column">{{itemPrice}}</div>' +
                                    '</div>' +
                                '</div>' +
                            '</li>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></a></li>',
    'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
    'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function(data) {
///// Product minimum Qty/ Step by it's handle/ID
  //var QtyStep = parseInt('{{ product.metafields.global.minimum_order_quantity }}');
  var QtyStep = '';
  var QtyMinOrder = '';

  if (isNaN(QtyMinOrder)) {
    // QtyMinOrder is NaN
    // Handle the NaN case
    QtyMinOrder = 5;
    QtyStep = 5;
  } else {
    // QtyMinOrder is a valid number
    // Continue with your logic
  }
var productID = data.id;

if(productID == 000000000000){
  QtyMinOrder = 1;
  QtyStep = 1;
}
else if(productID == 6736446849118){
  //All-In-One Deluxe Craft Box (Medium)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6773903786078){
  //All-In-One Jumbo Craft Box (Large)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6773903917150){
  //All-In-One Mega-Supreme Craft Box (Extra Large)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6773903261790){
  //All-In-One Starter Craft Box (Small)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6606373519454){
  //Australia Activity Bag with 3D Glasses and Markers - BULK BUY (200 units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6726556123230){
  //Blank Santa Sacks - Design your own - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6659020947550){
  //Bunny Ears Tote Bag - BULK BUY (box of 200)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788159635550){
  //Chicken Paper Bag Kit - BULK BUY 150 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619115880542){
  //Christmas 3D Activity Book - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6628183900254){
  //Christmas Colour-In Elf Headbands - BULK BUY (250)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6596834066526){
  //Christmas Colour-In Mask - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6799874490462){
  //Christmas Colour-In Santa Headbands - BULK BUY (250)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6714652983390){
  //Christmas Craft Elements Pack - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 3944712962142){
  //Christmas Door Hangers - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6736446849118){
  //Christmas Postcard Kit - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619114209374){
  //Christmas Santa Plush Toy - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619114045534){
  //Christmas Reindeer Plush Toy - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619114799198){
  //Christmas Santa Sack - BULK BUY- PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6597734760542){
  //Christmas Themed Colour-In Tote Bag - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619115946078){
  //Christmas Tree Colour-In Mask - BULK BUY- PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788157571166){
  //Colour-In Canvas Tote Bag - BULK BUY 150 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6597735186526){
  //Colour-In Christmas Stocking - BULK BUY (Mixed Designs) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806953427038){
  //Colour-In Christmas Stocking Gingerbread Man Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806953820254){
  //Colour-In Christmas Stocking Reindeer Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619115159646){
  //Colour-In Christmas Stocking Santa Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806954147934){
  //Colour-In Christmas Stocking Zentangle Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806944219230){
  //Colour-In Santa Hat Gingerbread Man Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806940614750){
  //Colour-In Santa Hat Ho-Ho! Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806945202270){
  //Colour-In Santa Hat Merry Christmas Design - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619115323486){
  //Colour-In Santa Hat Mixed Designs - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788160192606){
  //Colour-In Whoopee Cushion - BULK BUY 100 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788157014110){
  //Colour-Me-In Sustainable Insulated Tote - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6804950057054){
  //Design Your Own Spring Umbrella Activity - BULK BUY 80 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6537434529886){
  //Design Your Own Umbrella Activity - BULK BUY 80 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6755813556318){
  //Design-Your-Own Bunny Lantern Activity - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6736452976734){
  //DIY Chinese Lucky Red Packet Kit - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6755811852382){
  //DIY Chinese Lucky Red Packet Kit - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6805129953374){
  //DIY Christmas Bauble Kit - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6736446521438){
  //DIY Christmas Card Kit - BULK BUY (Box of 200)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6805133033566){
  //DIY Christmas Penguin Paper Bag Kit - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6760277344350){
  //DIY Easter Bunny Ears Crown Kit - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788161863774){
  //DIY ECO Planting Pot - BULK BUY 100 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788160290910){
  //DIY Embroidery Kit - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788158783582){
  //DIY Koala Ears Headband Kit - BULK BUY 200 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788160127070){
  //DIY Macramé Pot Holder Kit - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788159766622){
  //DIY Macramé Wall Hanging Kit - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788158914654){
  //DIY Pillowcase Kit - BULK BUY 100 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788156915806){
  //DIY Spoon City Kit - BULK BUY 200 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788160782430){
  //DIY Table Hockey Kit - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788160421982){
  //DIY Table Soccer Kit - BULK BUY 50 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788159373406){
  //DIY Wooden Plane Kit - BULK BUY 200 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6743033413726){
  //Easter Bunny Glitter Ears - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6651440005214){
  //Easter Colour-In Drawstring Bag Kits - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 1407737299038){
  //Easter Themed Tote Bag (Mixed Designs)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6760205353054){
  //Easter Themed Tote Bags - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788162617438){
  //ECO Pop-Up Pot Kit - Cactus Pattern - BULK BUY 200 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6788163076190){
  //ECO Pop-Up Pot Kit - Geometric Pattern - BULK BUY 200 UNITS
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6606373584990){
  //Eco-Friendly Healthy Eating Activity Bag - BULK BUY (200 Units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6606373683294){
  //Eco-Friendly Love Our World Sustainability Activity Bag - BULK BUY (200 Units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6606374109278){
  //Eco-Friendly My Cookbook Activity Bag - BULK BUY (200 Units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6606373617758){
  //Eco-Friendly Sports Activity Bag - BULK BUY (200 Units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619116044382){
  //Elf Colour-In Mask - BULK BUY - 250 Units - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 1421524893790){
  //Halloween Colour-In Tote Bag - BULK BUY (250 Units) STOCK ARRIVING END OF AUGUST
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6592228819038){
  //Halloween-Themed Colour-In Mask Kit - BULK BUY (250 Units)
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6763618074718){
  //Inspirational Quotes Activity & Colouring Book - BULK BUY 48 units
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775564599390){
  //It's Time to Build Activity Book (Book Only) - Bulk Buy
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6804952481886){
  //Kids Memory Board Game - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6804952711262){
  //Kids Pocket Games - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619114340446){
  //Letter to Santa Gift Bag Kit - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6755818504286){
  //Mini Easter Bunny Plush Toy - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6674185912414){
  //Mothers Day Activity Book BULK - Mandala Colouring- 48 Units
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6674186895454){
  //Mothers Day Premium Foil Mindful Colouring Book BULK -Colouring- 24Units
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775563911262){
  //My Cookbook Activity Book (Book Only) - Bulk Buy
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6774413230174){
  //NEW!! Indigenous Activity Book - "Let's Go On A Cultural Adventure" - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6739002785886){
  //Paint Your Own Christmas Ceramic Elf - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775562502238){
  //Queensland Activity Book with Markers and 3D Glasses - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6619116175454){
  //Reindeer Paper Bag Kit - BULK BUY - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6627680878686){
  //Robot Colour-In Mask - BULK BUY 250 Units
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6651452915806){
  //Rocket Mosaic Sticker Activity - BULK Pack of 20
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 1407738740830){
  //Safety Activity Book (Book Only) - Bulk Buy
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775558799454){
  //Safety Activity Book with Markers and 3D Glasses - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6589749919838){
  //Search and Find Activity Book - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775564763230){
  //Sports Activity Book (Book Only) - Bulk Buy
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6775535108190){
  //Sydney Activity Book with Markers and 3D Glasses - BULK BUY
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 1407733661790){
  //Victoria Activity Book with Markers and 3D Glasses - BULK BUY 250
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6807251517534){
  //Christmas Themed Colour-In Tote Bag - BULK BUY ($1.30 Per Unit) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6808726601822){
  //Christmas Themed Colour-In Tote Bag - Pack of 10 ($1.60 Per Unit) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6806944219230){
  //Colour-In Santa Hat - BULK BUY ($1.30 Per Unit)- PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6808742985822){
  //Colour-In Santa Hat - 10 Pack ($1.60 Per Unit) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6597735186526){
  //Colour-In Christmas Stocking - BULK BUY ($1.30 Per Unit) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else if(productID == 6808742232158){
  //Colour-In Christmas Stocking - 10 Pack ($1.60 Per Unit) - PRE-ORDER NOW!
 QtyMinOrder = 1;
 QtyStep = 1;
}
else {
  QtyMinOrder = 5;
  QtyStep = 5;
}
  
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add a specific class for grid item
  var itemGridWidthClass = '';
  var imageSize = '600x600';

  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      itemGridWidthClass = 'medium-up--one-half';
      imageSize = '540x600';
      break;
    case 3:
      itemGridWidthClass = 'small--one-half medium-up--one-third';
      imageSize = '345x550';
      break;
    case 4:
      itemGridWidthClass = 'small--one-half medium-up--one-quarter';
      imageSize = '250x';
      break;
    case 5:
      itemGridWidthClass = 'small--one-half medium-up--one-fifth';
      imageSize = '195x';
      break;
  }
  itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

  // Add soldOut class
  var itemSoldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

  // Add soldOut label
  var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

  var imgId = 'ProductCardImage-{{itemId}}';
  var wrapperId = 'ProductCardImageWrapper-{{itemId}}';

  // Build Image style
  var imageStyle = buildImageStyle(data);
  itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

  // Add Images
  var aspect_ratio = '';
  var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
  itemImagesHtml += '<div style="padding-top:';
  if (images.length > 0) {
    aspect_ratio = images[0]['width'] / images[0]['height'];
    itemImagesHtml += 1 / aspect_ratio * 100;
  } else {
    itemImagesHtml += 100;
  }
  itemImagesHtml += '%;">';
  itemImagesHtml += '<img id="' + imgId + '" ' +
    'class="grid-view-item__image lazyload" ' +
    'src="' + this.getFeaturedImage(images, '300x300') + '" ' +
    'data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' +
    'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
    'data-aspectratio="' + aspect_ratio + '" ' +
    'data-sizes="auto" ' +
    'alt="{{itemTitle}}">';
  itemImagesHtml += '</div>';
  itemImagesHtml += '</div>';

  var image_size = bcSfFilterConfig.custom.max_height + 'x' + bcSfFilterConfig.custom.max_height;
  var max_width = images.length > 0 ? bcSfFilterConfig.custom.max_height * aspect_ratio : 0;
  itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + this.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add Price 
  var itemPriceHtml = ''; 
//  if( bcSfFilterConfig.custom.customer_enable && bcSfFilterConfig.custom.customer && bcSfFilterConfig.custom.customer.indexOf('Can Buy') > -1){
    itemPriceHtml += buildPrice(data, onSale, priceVaries);
    if( data.available==true){
	//itemPriceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
	
	itemPriceHtml += '<span class="new-custom-price" data-regular-price>';
	itemPriceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
	itemPriceHtml += '</span>';
	
	
    itemPriceHtml += '<div id="product-form" item-id="' + productID +'">' +
                    '<input type="number" id="Quantity-collection-template" name="quantity" value="0" min="0" step="' + QtyStep + '" class="product-form__input" pattern="[0-9]*" MinQtyToOrder="' + QtyMinOrder + '">' +
                    '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
                    '<div class="collection_btn_addcart">' +
                    '<button type="submit" name="add" value="' + firstVariant.id + '" disabled>Add to cart</button>' +
                    '<p class="qty_notification">Quantity must be at least '  + QtyMinOrder + ' </p>' +
                    '</div>' +  
                    '</div>';
    }
	else{
	
	itemPriceHtml += '<span class="new-custom-price" data-regular-price>';
	itemPriceHtml += bcSfFilterConfig.label.sold_out;
	itemPriceHtml += '</span>';
	}
  //}
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));
  
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, this.truncateByChar(data.body_html, 200));

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
}

// Build Image style
function buildImageStyle(data) {
  var images = data.images_info;
  var imgId = 'ProductCardImage-{{itemId}}';
  var wrapperId = 'ProductCardImageWrapper-{{itemId}}';
  var imageStyle = '';
  if (images.length > 0) {
    var image = images[0];
    var width = bcSfFilterConfig.custom.max_height;
    var height = bcSfFilterConfig.custom.max_height;
    var aspect_ratio = image.width / image.height;
    var small_style = true;
    var container_aspect_ratio = width * 1.0 / height;

    if (image.aspect_ratio < 1.0) {
      var maximum_width = height * aspect_ratio;
      if (image.height <= height) {
        var maximum_height = image.height;
        maximum_width = image.width;
      } else {
        var maximum_height = height;
      }
    } else if (aspect_ratio < container_aspect_ratio) {
      var maximum_height = height / aspect_ratio;
      if (image.height <= height) {
        var maximum_height = image.height;
        var maximum_width = image.width;
      } else {
        var maximum_height = height;
        var maximum_width = height * aspect_ratio;
      }
    } else {
      var maximum_height = height / aspect_ratio;
      if (image.width <= width) {
        maximum_height = image.height;
        var maximum_width = image.width
      } else {
        var maximum_width = width;
        maximum_height = maximum_width / aspect_ratio;
      }
    }

    imageStyle += '<style>';
    if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
    imageStyle += '#' + imgId + ' {' +
      'max-width: ' + maximum_width + 'px;' +
      'max-height: ' + maximum_height + 'px;' +
      '}' +
      '#' + wrapperId + ' {' +
      'max-width: ' + maximum_width + 'px;' +
      'max-height: ' + maximum_height + 'px;' +
      '}';
    if (small_style) imageStyle += '}';

    if (small_style) {
      if (aspect_ratio < 1) {
        maximum_width = 750 * aspect_ratio;
      } else {
        if (image.width < 750) {
          maximum_width = image.width;
        } else {
          maximum_width = 750;
        }
      }
      imageStyle += '@media screen and (max-width: 749px) {'
      imageStyle += '#' + imgId + ' {' +
        'max-width: ' + maximum_width + 'px;' +
        'max-height: 750px;' +
        '}' +
        '#' + wrapperId + ' {' +
        'max-width: ' + maximum_width + 'px;' +
        '}';
      imageStyle += '}';
    }
    imageStyle += '</style>';
  }
  return imageStyle;
}

BCSfFilter.prototype.buildProductListItem = function(data) {
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Add onSale label
  var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

  // Add soldOut label
  var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Vendor
  var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorSmallListHtml : '';
  itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
  var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
  itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
}

function buildPrice(data, onSale, priceVaries) {
  var priceHtml = '',
    onSaleClass = onSale ? ' price--on-sale' : '';

  priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
  if (bcSfFilterConfig.custom.vendor_enable) {
    priceHtml += '<div class="price__vendor">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.vendor + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += data.vendor;
    priceHtml += '</dd>';
    priceHtml += '</div>';
  }
  priceHtml += '<div class="price__regular">';
  priceHtml += '<dt>';
  priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.regular_price + '</span>';
  priceHtml += '</dt>';
  priceHtml += '<dd>';
  priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
  if (data.available) {
    /* if (onSale) {
      priceHtml += bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat);
    } else {
      priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
    } */
	priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
  } else {
    priceHtml += bcSfFilterConfig.label.sold_out;
  }
  priceHtml += '</span>';
  priceHtml += '</dd>';
  priceHtml += '</div>';
  priceHtml += '<div class="price__sale">';
  priceHtml += '<dt>';
  priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.sale_price + '</span>';
  priceHtml += '</dt>';
  priceHtml += '<dd>';
  priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
  priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
  priceHtml += '</span> ';
  priceHtml += '<span class="price-item__label" aria-hidden="true">' + bcSfFilterConfig.label.sale + '</span>';
  priceHtml += '</dd>';
  priceHtml += '</div>';
  priceHtml += '</dl>';

  return priceHtml;
  
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }

  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;

    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Build page items
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);

    jQ(this.selector.pagination).html(paginationHtml);
  }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>View As </span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
  jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
  }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */
  var productSelector = jQ(this.selector.products);
  if (this.queryParams.display == 'list') {
    if (productSelector.children('.list-view-items').length == 0) {
      productSelector.children().wrapAll('ul class="list-view-items"/>');
    }
    productSelector.removeClass('grid grid--uniform grid--view-items');
  } else {
    if (productSelector.children('.list-view-items').length > 0) {
      productSelector.children('.list-view-items').children().unwrap();
    }
    productSelector.addClass('grid grid--uniform grid--view-items');
  }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var totalProduct = '';
  if (data.total_product == 1) {
    totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
  } else {
    totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
}


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
